import { apiRequest } from './api';
import type {
  EmployeeScheduleResponse,
  CurrentWeekResponse,
  UpsertScheduleRequest,
  TeamSchedulesResponse,
  HolidayDTO,
} from '@functieloonhuis/shared';

export const workScheduleApi = {
  getByEmployee: (employeeId: number) =>
    apiRequest<{ data: EmployeeScheduleResponse }>(`/work-schedules/employee/${employeeId}`),

  upsertSchedule: (employeeId: number, body: UpsertScheduleRequest) =>
    apiRequest<{ data: EmployeeScheduleResponse }>(`/work-schedules/employee/${employeeId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }),

  deleteSchedule: (employeeId: number) =>
    apiRequest<void>(`/work-schedules/employee/${employeeId}`, {
      method: 'DELETE',
    }),

  getCurrentWeek: () =>
    apiRequest<{ data: CurrentWeekResponse }>('/work-schedules/current-week'),

  getTeamSchedules: () =>
    apiRequest<TeamSchedulesResponse>('/work-schedules/team'),

  getAllSchedules: () =>
    apiRequest<TeamSchedulesResponse>('/work-schedules/all'),

  getHolidays: (year: number) =>
    apiRequest<{ data: HolidayDTO[] }>(`/holidays?year=${year}`),
};
